export default __webpack_public_path__ + "static/media/consulting.2f45fc9f.png";